import { Transform, Type } from 'class-transformer';

export class PayOrderExportFilter {
  @Type()
  ourLegalEntityId?: number;

  @Type()
  bankAccountId?: number;
}
